const Page = {
  //private routes
  APP: "/app/",
  DASHBOARD: "dashboard",
  MANAGERS: "managers",
  PROFILE: "profile",
  AFFILIATES: "affiliate",
  AFFILIATE_EDIT: "affiliate/edit/:id",
  AFFILIATE_DETAILS: "affiliate/:affiliateName/:id",
  AFFILIATE_CREATE: "affiliate/create",
  REPORTS: "reports",
  CLICKS: "clicks",
  REGISTRATIONS: "registrations",
  REGISTERING: "Registering",
  BRAND_GROUPS: "brand_groups",
  BRAND_GROUP: "brand_groups/:id",
  CAMPAIGNS: "campaign",
  CAMPAIGNS_TEST: "campaigns-test",
  PIXEL: "pixel",
  PROMO_CODES: "promo-codes",
  TENANT: "t-settings",
  CAMPAIGNS_EDIT: "campaign/edit/:id",
  CAMPAIGN_TAB: "campaigns/:tab",
  CAMPAIGN_DETAILS: "campaign/:campaignName/:id",
  CAMPAIGN_CREATE: "campaign/create",
  GEO_ADD: "geo/edit",
  GEO_EDIT: "geo/edit/:id?",
  POSTBACK_LOGS: "postback_logs",
  POSTBACKS: "postbacks",
  COHORT_ANALYSIS: "cohortAnalysis",
  CLICKS_ANALYSIS: "clicksAnalysis",
  PERFORMANCE_REPORT: "performanceReport",
  BRANDS: "brand",
  BRAND_CREATE: "brand/create",
  BRAND_EDIT: "/brand/edit/:id",
  BRAND_DETAILS: "brand/:brandName/:id",
  PAYOUTS: "payouts",
  CONVERSIONS: "conversions",
  MARKETING_TOOLS: "marketing_tools",
  REDISTRIBUTION: "redistribution",
  REDISTRIBUTION_ADD: "redistribution/add",
  REDISTRIBUTION_TAB: "redistribution/:tab",
  REDISTRIBUTION_FILES_DETAIL: "redistribution/files/:id",
  OFFERS: "offer",
  OFFER_CREATE: "offer/create",
  OFFER_EDIT: "offer/edit/:id",
  PAYMENT: "payment",
  AFFILIATE_BALANCE: "aff-balance",
  TENANT_BALANCE: "balance",
  INVOICE: "invoice",
  RESET_PASSWORD: "reset-password/:token",
  REQUEST_DETAILS: "payment/request-details/:id",
  INVOICE_DETAILS: "invoice/invoice-details/:id",
  OFFER_DETAILS: "offer/:name/:id",
  DEPOSIT_DETAILS: "balance/deposit-details/:id",
  PAYMENT_DETAILS: "balance/payment-details/:id",
  QUALIFICATIONS: "qualifications",
  QUALIFICATIONS_ANALYSIS: "qualificationsAnalysis",
  REPORT_BUILDER: "report-builder",
  REPORT_BUILDER_CREATE: "report-builder/create",
  REPORT_BUILDER_EDIT: "report-builder/:id",
  QUALIFICATION_CREATE: "qualifications/create",
  QUALIFICATION_EDIT: "qualifications/edit/:id",
  QUALIFICATION_DETAILS: "qualifications/:name/:id",
  PROMO_MATERIALS: "promo-materials",
  REPORT_DETAILS: "report-builder/:name/:id",
  FORMULAS: "formulas",

  //public routes
  CONFIRM_EMAIL_STATUS: "/confirm-email/:status",
  CONFIRM_EMAIL: "/confirm-email",

  SIGN_IN: "/login",
  SIGN_UP: "/register",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  SIGN_UP_SUCCESS: "/sign-up-success/:id",
  FORGOT_PASSWORD: "/forgot-password",
  SIGN_OUT: "/logout",
  LOCK_SCREEN: "/lock-screen",

  ERROR400: "/error400",
  ERROR404: "/error404",
  VERIFY: "/url-verification",
  ERROR500: "/error500",
  ERROR503: "/error503",
};

Object.freeze(Page);
export default Page;
